<script setup lang="ts">
import {storeToRefs} from "pinia";
import {DashboardRangeStore} from "@/scripts/store/dashboard_range.store";
import {useAnalytics} from "@/scripts/store/analytics";
import VLoader from "@/scripts/components/app/common/VLoader.vue";
import {ref} from "vue";
import {useAccount} from "@/scripts/store/account";

export interface Props {
    codeIdentifier: String
}

const props = defineProps<Props>();
const isLoading = ref(false)

const dashboardRange = DashboardRangeStore()
const analytics = useAnalytics();

const {currentRange} = storeToRefs(dashboardRange)

const subscription = useAccount()
const {account} = storeToRefs(subscription);
const {scansForEachHourData} = storeToRefs(analytics);
const isAvailableForCurrentPlan = account.value.currentPlan.label !== 'free'

const series = ref([{
    data: [400, 430, 448, 470, 540, 580, 690, 1100, 1200, 1380]
}]);

const chartOptions = ref({
    chart: {
        type: 'bar',
        height: 350
    },
    plotOptions: {
        bar: {
            borderRadius: 4,
            horizontal: true,
        }
    },
    dataLabels: {
        enabled: false
    },
    xaxis: {
        categories: [
            '00:00',
            '01:00',
            '02:00',
            '03:00',
            '04:00',
            '05:00',
            '06:00',
            '07:00',
            '08:00',
            '09:00',
            '10:00',
            '11:00',
            '12:00',
            '13:00',
            '14:00',
            '15:00',
            '16:00',
            '17:00',
            '18:00',
            '19:00',
            '20:00',
            '21:00',
            '22:00',
            '23:00',
        ],
    }
});

const refreshSeries = async () => {

    if (!isAvailableForCurrentPlan) {
        return
    }

    isLoading.value = true

    await analytics.loadScansForEachHour(currentRange.value.from, currentRange.value.to, props.codeIdentifier)

    const seriesData = []

    for (const item of scansForEachHourData.value) {
        seriesData.push(item.count)
    }

    series.value = [{data: seriesData}]

    isLoading.value = false
};

refreshSeries();

dashboardRange.$subscribe((mutation, state) => {
    refreshSeries()
})

</script>

<template>
    <div class="bg-white overflow-hidden shadow sm:rounded-lg">
        <div class="px-4 py-5 sm:p-6">
            <div>
                Распределение по часам
            </div>
            <div v-if="isAvailableForCurrentPlan">
                <div v-if="!isLoading">
                    <apexchart type="bar" height="350" :options="chartOptions" :series="series"></apexchart>
                </div>
                <div v-else>
                    <v-loader class="mt-2"></v-loader>
                </div>
            </div>
            <div class="mt-8" v-else>
                <span
                    class="cursor-pointer inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
                    <a href="/billing">
                        недоступно на free плане
                    </a>
                </span>
            </div>
        </div>
    </div>
</template>

